const sanitizeCanonical = (
  baseUrl: string,
  pathname: string,
  query: object,
  queryWhiteList?: Array<string>
): string => {
  const url = pathname === '/' ? baseUrl : baseUrl + pathname;
  const paramKeys = Object.entries(query);
  const allowedQueries = paramKeys
    .filter(param => queryWhiteList.includes(param[0]))
    .map(params => params.join('='))
    .join('&');
  if (allowedQueries.length > 0) {
    return url + '?' + allowedQueries;
  }
  return url;
};

export default sanitizeCanonical;
